<div class="video-container row" [dir]="language === 'ar' ? 'rtl' : 'ltr'">
  <h3 *ngIf="data?.title">{{ data.titleTr }}</h3>
  <div class="col-12 col-md-7 order-2 order-md-1">
    <div [innerHTML]="data.htmlContent" *ngIf="data?.htmlContent"></div>
  </div>
  <div class="image col-12 col-md-5 order-1 order-md-2">
    <video width="100%" autoplay controls muted *ngIf="data.video">
      <source [src]="data.video" type="video/mp4" />
      <source [src]="data.video" type="video/ogg" />
    </video>
    <img *ngIf="!data.video" [src]="data.imageUrl" />
  </div>
</div>
